import { useDispatch, useSelector } from "react-redux";
import { decodeJwt } from "../utils/decodeJwt";
import {
  saveCountries,
  saveLanguages,
} from "../features/dashboard/dashboardSlice";
import { CountryProps, LanguageProps } from "../features/dashboard/types";
import {
  fetchCountryList,
  fetchLanguageList,
} from "../features/dashboard/dashboardApi";

export default function usePublicData() {
  const dashboard = useSelector((state: any) => state.dashboard);
  const dispatch = useDispatch();
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  const fetchPublicData = async () => {
    const decoded = token ? decodeJwt(`token=${token}`) : null;

    if (!token || !decoded) {
      return;
    }

    if (dashboard?.countries?.length === 0) {
      const countries: CountryProps[] = await fetchCountryList();
      dispatch(saveCountries(countries));
    }
    if (dashboard?.languages?.length === 0) {
      const languages: LanguageProps[] = await fetchLanguageList();
      dispatch(saveLanguages(languages));
    }
  };

  return { fetchPublicData };
}
